module.exports = __webpack_public_path__ + "static/worksafe-stf-dashboard-ee71d50f4976ccc50edb4d8113829eec.png";